import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/*
 * CurrentGameParams.ts
 */
export class CurrentGameParams {
    constructor(roomName) {
        this.roomName = roomName;
    }
    liquify() {
        let data = new DataObject();
        data.putString(SlingoConstants.PROPERTY_ROOM_NAME, this.roomName);
        return data;
    }
}
//# sourceMappingURL=CurrentGameParams.js.map